<template>
  <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Registro, Modificacion de Rios y Sectores </h3>
            <h6 align="right"></h6>
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-init-river-tab" data-toggle="tab" href="#nav-init-river" role="tab" aria-controls="nav-home" aria-selected="true">Registro de Rios</a>
                    <a class="nav-item nav-link" id="nav-second-river-tab" data-toggle="tab" href="#nav-second-river" role="tab" aria-controls="nav-detail" aria-selected="false" >Modificacion de datos de Rios</a>
                    <a class="nav-item nav-link " id="nav-tirdh-river-tab" data-toggle="tab" href="#nav-tirdh-river" role="tab" aria-controls="nav-property" aria-selected="false" @click="mEnterTab">Registro de Sector</a>
                    <a class="nav-item nav-link " id="nav-fourth-river" data-toggle="tab" href="#nav-four-river" role="tab" aria-controls="nav-motor" aria-selected="false">Modificacion Sector</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                 <div class="tab-pane fade show active" id="nav-init-river" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h6>REGISTRO DE RIO</h6>
                    <hr>

                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Nombre Rio/Lago <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake.name" id="river_lake_name" placeholder="Nombre Rio" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Cuenca <span class="required-text">*</span></label>                    
                            <select name="basin" id="basin" v-model="river_lake.basin" class="form-control">
                                <option v-for="bl in list_basin" :key="bl.id" :value="bl.id">{{ bl.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Inicio/Naciente <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake.init" id="begining_lake" placeholder="Inicio Rio/Lago" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Finalizacion/Desemboque <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake.end" id="finish_lake" placeholder="Final conclusion Rio/Lago" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <label for="nombre_embarcacion">Descripcion <span class="required-text">*</span></label>
                            <textarea name="description_river_lake" id="description_river_lake" cols="30" rows="5" class="form-control" placeholder="Descripcion del Rio/Lago" v-model="river_lake.description"></textarea>
                        </div>
                    </div>

                    <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                    <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" @click="saveRiver">
                        <font-awesome-icon icon="save" size="3x" />
                    </button>

                 </div>

                 <div class="tab-pane fade show" id="nav-second-river" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h6>MODIFICACION DATOS RIOS</h6>
                    <hr>

                    <div class="form-row">
                        <div class="form-group col col-md-4 offset-md-4">
                            <label for="list_lake">Rio/lago</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="lake_select" @change="mSelectRiver">
                                <option v-for="lr in list_river" :key="lr.id" :value="lr">{{ lr.name_lake }} - {{ lr.cuenca }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="river_lake_edit.id_lake > 0">
                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Nombre Rio/Lago <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake_edit.name_edit" id="river_lake_name" placeholder="Nombre Rio" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Cuenca <span class="required-text">*</span></label>                    
                            <select name="basin" id="basin" v-model="river_lake_edit.basin_edit" class="form-control">
                                <option v-for="bl in list_basin" :key="bl.id" :value="bl.id">{{ bl.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Inicio/Naciente <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake_edit.init_edit" id="begining_lake" placeholder="Inicio Rio/Lago" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="nombre_embarcacion" >Finalizacion/Desemboque <span class="required-text">*</span></label>                    
                            <input type="text" class="form-control" v-model="river_lake_edit.end_edit" id="finish_lake" placeholder="Final conclusion Rio/Lago" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col">
                            <label for="nombre_embarcacion">Descripcion <span class="required-text">*</span></label>
                            <textarea name="description_river_lake" id="description_river_lake" cols="30" rows="5" class="form-control" placeholder="Descripcion del Rio/Lago" v-model="river_lake_edit.description_edit"></textarea>
                        </div>
                    </div>

                    <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                    <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" @click="updateRiver">
                        <font-awesome-icon icon="save" size="3x" />
                    </button>
                    </div>

                 </div>

                 <div class="tab-pane fade show" id="nav-tirdh-river" role="tabpanel" aria-labelledby="nav-home-tab" >
                    <h6>REGISTRO DE SECTOR</h6>
                    <hr>

                    <div class="form-row">
                        <div class="form-group col col-md-4 offset-md-4">
                            <label for="list_lake">Rio/lago</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="sector_register.id_lake" @change="mSelectRiverSector">
                                <option v-for="lr in list_river" :key="lr.id" :value="lr.id">{{ lr.name_lake }} - {{ lr.cuenca }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="sector_register.id_lake > 0">
                        <div class="form-row">
                            <div class="form-group col col-md-8">
                                <label for="nombre_embarcacion" >Sector <span class="required-text">*</span></label>                    
                                <input type="text" class="form-control" v-model="sector_register.sector" id="river_lake_name" placeholder="Sector" autocomplete="off">
                            </div>
                            <div class="form-group col col-md-4">
                                <label for="nombre_embarcacion" >Profundidad "metros"<span class="required-text">*</span></label>                    
                                <input type="number" class="form-control" v-model="sector_register.deep_lake" id="river_lake_name" placeholder="Nombre Rio" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col col-md-12">
                                <label for="sector_descripcion">Descripcion <span class="required-text">*</span></label>
                                <textarea name="description_river_lake" id="sector_register" cols="30" rows="5" class="form-control" placeholder="Descripcion del Sector" v-model="sector_register.description"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-md-12">
                                <CargarMapa v-if="renderComponenttwo"
                                    :configMapa="configMapa"
                                    apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
                                >

                                    <template slot-scope="{ google, map }">
                                    <NuevoMarcador
                                        ref="newMark"
                                        :marker=cNewLocation[0]
                                        :google="google"
                                        :map="map"
                                    />
                                    </template>

                                </CargarMapa>
                            </div>
                        </div>
                            <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                            <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="disabled_sector" @click="mSaveNewSector">
                                <font-awesome-icon icon="save" size="3x" />
                            </button>
                        </div>
                </div>

                <div class="tab-pane fade show" id="nav-four-river" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h6>MODIFICACION DE SECTOR</h6>
                    <hr>

                    <div class="form-row">
                        <div class="form-group col col-md-3 offset-md-3">
                            <label for="list_lake">Rio/lago</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="sector_register_edit.id_lake" @change="mSelectRiverEditSector">
                                <option v-for="lr in list_river" :key="lr.id" :value="lr.id">{{ lr.name_lake }} - {{ lr.cuenca }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md-3" v-if="list_sector_register.length > 0">
                            <label for="list_lake">Sector</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="sector_register_edit.id_sector" @change="mSelectSectorEdit">
                                <option v-for="lreg in list_sector_register" :key="lreg.id_sector" :value="lreg">{{ lreg.sector }}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div v-if="sector_edit_aux.id_sector > 0">
                        <div class="form-row">
                            <div class="form-group col col-md-6">
                                <label for="nombre_embarcacion" >Sector <span class="required-text">*</span></label>                    
                                <input type="text" class="form-control" v-model="sector_edit_aux.sector" id="river_lake_name" placeholder="Sector" autocomplete="off">
                            </div>
                            <div class="form-group col col-md-4">
                                <label for="nombre_embarcacion" >Profundidad "metros"<span class="required-text">*</span></label>                    
                                <input type="number" class="form-control" v-model="sector_edit_aux.deep_lake" id="river_lake_name" placeholder="Nombre Rio" autocomplete="off">
                            </div>
                            <div class="form-group col col-md-2">
                                <label for="state_sector" >Estado<span class="required-text">*</span></label>
                                <select name="state_sector" id="state_sector" class="form-control" v-model="sector_edit_aux.status">
                                    <option value="A">Activo</option>
                                    <option value="I">Inactivo</option>
                                </select>                    
                                
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col col-md-12">
                                <label for="sector_descripcion">Descripcion <span class="required-text">*</span></label>
                                <textarea name="description_river_lake" id="sector_edit_aux" cols="30" rows="5" class="form-control" placeholder="Descripcion del Sector" v-model="sector_edit_aux.description"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-md-12">
                                <CargarMapaAux v-if="renderComponent"
                                    :configMapa="configMapa"
                                    apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
                                >

                                    <template slot-scope="{ google, map }">
                                    <NuevoMarcador
                                        ref="newMark"
                                        :marker=cNewLocation[0]
                                        :google="google"
                                        :map="map"
                                    />
                                    </template>

                                </CargarMapaAux>
                            </div>
                        </div>
                            <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                            <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="disabled_sector_edit" @click="mUpdateSector">
                                <font-awesome-icon icon="save" size="3x" />
                            </button>
                        </div>
                    </div>
            </div>
        </div>

  </div>

</template>

<script>
import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';

  import CargarMapa from "../maps/LoadMap";
  import CargarMapaAux from "../maps/LoadMap";
  import Marcadores from "../maps/MarksMaps";
  import NuevoMarcador from '../maps/NewMarkMap';
  
  import NuevoMarcadorAux from '../maps/NewMarkMap';

  import { configMapa } from "@/constants/configMapa";

export default {
    name:'river-lake',
    mounted(){
        this.mChargeInit();
        this.mListRiver();
    },
    data(){
        return{
            id_modal_progress:'loading_lake',
            title_modal:'Solucionando',
            send_dispatch:true,
            btn_r_river:true,
            river_lake:{
                name:null,
                init:null,
                end:null,
                description:null,
                basin:0
            },
            list_basin:[],
            list_river:[],
            lake_select:{id:0},
            river_lake_edit:{
                id_lake:0,
                name_edit:null,
                init_edit:null,
                end_edit:null,
                description_edit:null,
                basin_edit:0
            },
            sector_register:{
                id_lake:0,
                sector:null,
                deep_lake:0,
                description:null,
                latitud:0,
                longitud:0
            },
            disabled_sector:false,
            sector_register_edit:{
                id_lake:0,
                id_sector:{id_sector:0}
            },
            sector_edit_aux:{
                id_lake:0,
                id_sector:0,
                sector:null,
                deep_lake:0,
                description:null,
                latitud:0,
                longitud:0,
                status:null
            },
            disabled_sector_edit:false,
            list_sector_register:[],
            markerOld:{
                    index:"0",
                    position: { lat: -14.870719, lng: -64.967 },
                    title:'Nueva Ubicacion'
            },
            renderComponent:false,
            renderComponenttwo:false
        }
    },
    methods:{
        mEnterTab(){
            console.log('haciendo click sobre el tab');
            this.forceRerender(2);
        },
        mSelectRiverSector(){
           this.forceRerender(2);
        },
        forceRerender(c=1) {
            // Remove my-component from the DOM
            if(c===1){
                this.renderComponent = false;

                // also use nextTick this way
                this.$nextTick().then(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            }else{
                this.renderComponenttwo = false;

                // also use nextTick this way
                this.$nextTick().then(() => {
                    // Add the component back in
                    this.renderComponenttwo = true;
                });
            }
                
        },
        mValidateUpdateSector(){
            if(this.sector_edit_aux.id_lake===0){
                toastr.error('Seleccione un Rio o Lago Principal', 'Error');
                return false;
            }

            if(this.sector_edit_aux.sector===null){
                toastr.error('Indique el Sector', 'Error');
                return false;
            }

            if(this.sector_edit_aux.dep_lake===0){
                toastr.error('Indique la profundidad del sector', 'Error');
                return false;
            }

            if(this.sector_edit_aux.description===null){
                toastr.error('Indique una breve descipcion del sector', 'Error');
                return false;
            }

            return true;
        },
        mUpdateSector(){
            if(this.mValidateUpdateSector()){
                // enviar los datos al servidor
                let message = {
                    title: `Actualizar el Sector`,
                    body: `¿Desea Actualizar los datos del Sector <b>${this.sector_edit_aux.sector}?</b>`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            let dtsSector={
                                id_sector:this.sector_edit_aux.id_sector,  
                                id_lake:this.sector_edit_aux.id_lake,
                                sector:this.sector_edit_aux.sector,
                                deep_lake:this.sector_edit_aux.deep_lake,
                                description:this.sector_edit_aux.description,
                                status:this.sector_edit_aux.status,
                                lat:this.cNewLocationPosition.lat,
                                lng:this.cNewLocationPosition.lng
                            }

                            // console.log(dtsSector);
                            this.disabled_sector_edit=true;
                            // this.activeModal(this.id_modal_progress);
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let u_sector = await axios.post(`updateSectorLake?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsSector));
                            setTimeout(()=>{                                
                                if(u_sector.data.status){
                                    toastr.success(u_sector.data.response);
                                    // detenemos la animacion
                                    this.mResetSectorUpdate();
                                    this.mSelectRiverEditSector();
                                    this.disabled_sector_edit=false;  

                                }else{
                                    toastr.success(u_sector.data.response);
                                    // detenemos la animacion
                                    this.disabled_sector_edit=false;
                                }
                            },3000)

                        }catch(err){
                            console.log('error al registrar');
                            this.disabled_sector=false;
                            // setTimeout(()=>{
                            //     toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                            //     this.btn_p_ordop = false;
                            //     this.inactiveModal(this.id_modal_progress);
                            // }, 3000)
                        }
                    }else{
                        console.log('No se guardo la nueva lozalizacion de la capitania')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }
        },
        mValidateNewSector(){
            if(this.sector_register.id_lake===0){
                toastr.error('Seleccione un Rio o Lago Principal', 'Error');
                return false;
            }

            if(this.sector_register.sector===null){
                toastr.error('Indique el Sector', 'Error');
                return false;
            }

            if(this.sector_register.dep_lake===0){
                toastr.error('Indique la profundidad del sector', 'Error');
                return false;
            }

            if(this.sector_register.description===null){
                toastr.error('Indique una breve descipcion del sector', 'Error');
                return false;
            }

            return true;
        },
        mSaveNewSector(){
            // validar los datos
            if(this.mValidateNewSector()){
                // enviar los datos al servidor
                let message = {
                    title: `Registro del Sector`,
                    body: `¿Desea Registrar los datos del Sector <b>${this.sector_register.sector}?</b>`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            let dtsSector={
                              id_lake:this.sector_register.id_lake,
                              sector:this.sector_register.sector,
                              deep_lake:this.sector_register.deep_lake,
                              description:this.sector_register.description,
                              lat:this.cNewLocationPosition.lat,
                              lng:this.cNewLocationPosition.lng
                            }

                            // console.log(dtsSector);
                            this.disabled_sector=true;
                            // this.activeModal(this.id_modal_progress);
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let r_sector = await axios.post(`registerSectorLake?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsSector));
                            setTimeout(()=>{                                
                                if(r_sector.data.status){
                                    toastr.success(r_sector.data.respuesta);
                                    // detenemos la animacion
                                    this.mResetSectorRegister();
                                    this.disabled_sector=false;  

                                }else{
                                    toastr.success(r_sector.data.respuesta);
                                    // detenemos la animacion
                                    this.disabled_sector=false;
                                }
                            },3000)

                        }catch(err){
                            console.log('error al registrar');
                            this.disabled_sector=false;
                            // setTimeout(()=>{
                            //     toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                            //     this.btn_p_ordop = false;
                            //     this.inactiveModal(this.id_modal_progress);
                            // }, 3000)
                        }
                    }else{
                        console.log('No se guardo la nueva lozalizacion de la capitania')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }            
        },
        async mChargeInit(){
            let basin_reg=await axios.get(`globals/basin?api_token=${Vue.auth.getToken()}`);
            this.list_basin=basin_reg.data;
        },
        mValidateRegRiver(){
            if(this.river_lake.name === null){
                toastr.warning('Indique el Nombre del Lago o Rio', 'Error');
                return false;
            }

            if(this.river_lake.basin === 0){
                toastr.warning('Seleccione una cuenca', 'Error');
                return false;
            }

            if(this.river_lake.init === null){
                toastr.warning('indique el inicio o el naciente del Rio o Lago', 'Error');
                return false;
            }

            if(this.river_lake.end === null){
                toastr.warning('indique el final o desemboque del Rio o Lago', 'Error');
                return false;
            }

            if(this.river_lake.description === null){
                toastr.warning('indique una descripcion del Rio o Lago', 'Error');
                return false;
            }

            return true;
        },
        mValidateUpdRiver(){
            if(this.river_lake_edit.name_edit === null){
                toastr.warning('Indique el Nombre del Lago o Rio', 'Error');
                return false;
            }

            if(this.river_lake_edit.basin_edit === 0){
                toastr.warning('Seleccione una cuenca', 'Error');
                return false;
            }

            if(this.river_lake_edit.init_edit === null){
                toastr.warning('indique el inicio o el naciente del Rio o Lago', 'Error');
                return false;
            }

            if(this.river_lake_edit.end_edit === null){
                toastr.warning('indique el final o desemboque del Rio o Lago', 'Error');
                return false;
            }

            if(this.river_lake_edit.description_edit === null){
                toastr.warning('indique una descripcion del Rio o Lago', 'Error');
                return false;
            }

            return true;
        },
        updateRiver(){
            console.log(`actualizando el rio o lago`);
            if(this.mValidateUpdRiver()){
                let message = {
                    title: 'Actualizacion del Rio u Lago',
                    body: '¿Desea Actualizar el registro del Rio o Lago?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.btn_p_ordop = true;
                            // this.activeModal(this.id_modal_progress);

                            // let reg_lake=JSON.stringify(this.river_lake);
                            let s_upd_lake=await axios.post(`updateLake?api_token=${Vue.auth.getToken()}`, qs.stringify(this.river_lake_edit));
                            if(s_upd_lake.data.status){
                                    this.mResetFormUpdateLake();
                                    this.mListRiver();
                                    toastr.success(s_upd_lake.data.response);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    // let aid=this.process_ordop.id;
                                    // this.mCloseOrdop(aid);
                                    // limpiamos los registros previamente obtenemos el id
                            }else{
                                toastr.error(s_upd_lake.data.response);
                            }
                            setTimeout(()=>{    
                                // this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el registro del lago', 'Error O-01')
                                this.btn_p_ordop = false;
                                // this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }
            
        },
        saveRiver(){
            if(this.mValidateRegRiver()){
                
                 let message = {
                    title: 'Registro del Rio u Lago',
                    body: '¿Desea Registrar el Rio o Lago?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.btn_p_ordop = true;
                            // this.activeModal(this.id_modal_progress);

                            // let reg_lake=JSON.stringify(this.river_lake);
                            let s_reg_lake=await axios.post(`registerLake?api_token=${Vue.auth.getToken()}`, qs.stringify(this.river_lake));
                            if(s_reg_lake.data.status){
                                    this.mResetFormRegister();
                                    
                                    toastr.success(s_reg_lake.data.respuesta);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // this.btn_p_ordop = false;
                                    // let aid=this.process_ordop.id;
                                    // this.mCloseOrdop(aid);
                                    // limpiamos los registros previamente obtenemos el id
                            }else{
                                toastr.error(s_reg_lake.data.respuesta);
                            }
                            setTimeout(()=>{    
                                // this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el registro del lago', 'Error O-01')
                                this.btn_p_ordop = false;
                                // this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
                
            }else{
                console.log('no se guardo la ordop');
            }
        },
        mResetFormRegister(){            
            this.river_lake.name=null;
            this.river_lake.init=null;
            this.river_lake.end=null;
            this.river_lake.description=null;
            this.river_lake.basin=0;
        },
        mResetFormUpdateLake(){
            this.river_lake_edit.id_lake=0; 
            this.river_lake_edit.name_edit=null;
            this.river_lake_edit.init_edit=null;
            this.river_lake_edit.end_edit=null;
            this.river_lake_edit.description_edit=null;
            this.river_lake_edit.basin_edit=0;
        },
        mResetSectorRegister(){
            this.sector_register.id_lake=0;
            this.sector_register.sector=null;
            this.sector_register.description=null;
            this.sector_register.deep_lake=0;
            this.sector_register.lat=0;
            this.sector_register.lng=0;
        },
        mResetSectorUpdate(){
            this.sector_edit_aux.id_lake=0;
            this.sector_edit_aux.id_sector=0;
            this.sector_edit_aux.sector=null;
            this.sector_edit_aux.deep_lake=null;

            this.sector_edit_aux.description=null;
            this.sector_edit_aux.latitud=null;
            this.sector_edit_aux.longitud=null;
            this.sector_edit_aux.status=null;
        },
        mSelectRiver(){
            // console.log(this.lake_select);
            this.river_lake_edit.id_lake=this.lake_select.id;
            this.river_lake_edit.name_edit=this.lake_select.name_lake;
            this.river_lake_edit.init_edit=this.lake_select.begin;
            this.river_lake_edit.end_edit=this.lake_select.end;
            this.river_lake_edit.description_edit=this.lake_select.description;
            this.river_lake_edit.basin_edit=this.lake_select.code_basin;
        },
        async mSelectRiverEditSector(){
            this.list_sector_register=[];
            this.mResetSectorEdit();
            // console.log(this.sector_register_edit.id_sector.id_sector);
            // this.sector_register_edit.id_sector.id_sector=0;
            // console.log(this.sector_register_edit.id_sector.id_sector);
            let r_sector=await axios.get(`getSectorRegister/${this.sector_register_edit.id_lake}?api_token=${Vue.auth.getToken()}`);
            // console.log(r_sector);
            this.list_sector_register=r_sector.data;
        },
        mSelectSectorEdit(){
            this.sector_register_edit.id_sector;
            // console.log(this.sector_register_edit.id_sector);
            
            this.sector_edit_aux.id_lake=this.sector_register_edit.id_sector.id_river_lake,
            this.sector_edit_aux.id_sector=this.sector_register_edit.id_sector.id_sector,
            this.sector_edit_aux.sector=this.sector_register_edit.id_sector.sector,
            this.sector_edit_aux.deep_lake=this.sector_register_edit.id_sector.deep_river_lake,
            this.sector_edit_aux.description=this.sector_register_edit.id_sector.description,
            this.sector_edit_aux.latitud=this.sector_register_edit.id_sector.latitud,
            this.sector_edit_aux.longitud=this.sector_register_edit.id_sector.longitud
            this.sector_edit_aux.status=this.sector_register_edit.id_sector.status
            
            console.log(this.markerOld);

            this.markerOld.position.lat=parseFloat(this.sector_register_edit.id_sector.latitud);
            this.markerOld.position.lng=parseFloat(this.sector_register_edit.id_sector.longitud);

            this.$store.dispatch('sGoogleMaps/addNewPosition',this.markerOld);

            console.log(this.markerOld);
            setTimeout(()=>{
                this.forceRerender();
                
            }, 2000)
            
        },
        mResetSectorEdit(){
            this.sector_edit_aux.id_lake=0;
            this.sector_edit_aux.id_sector=0;
            this.sector_edit_aux.sector=null;
            this.sector_edit_aux.deep_lake=0,
            this.sector_edit_aux.description=null,
            this.sector_edit_aux.latitud=null;
            this.sector_edit_aux.longitud=null;
        },
        async mListRiver(){
            let listRiver=await axios.get(`getListLake?api_token=${Vue.auth.getToken()}`);
            // console.log(listRiver);
            this.list_river=listRiver.data;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    components: {
      CargarMapa,
      CargarMapaAux,
      Marcadores,
      NuevoMarcador,
      NuevoMarcadorAux
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      },
      cMarkOld(){
          return this.markerOld;
      },
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cNewLocation(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getLocation'];
      },
      cNewLocationPosition(){
        return this.$store.getters['sGoogleMaps/getLocationPosition'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cNewLocation[0].position;
      },
    }
}
</script>

<style>
.required-text{
    color:red; 
    font-weight:bold;
}
</style>


// WEBPACK FOOTER //
// src/components/river/riverLake.vue